<template lang='pug'>
  div
    v-select(v-if='!error'
      :value='value'
      @input='change'
      :loading='loading'
      :items='channels'
      item-text='name'
      return-object
      label='Slack Channel'
      required
      :rules='required')
    div(v-if='error').text-body-2 Unable to communicate with Slack. Please make sure the slack app is installed from the integrations page:&nbsp;
      router-link(to='/integrations') Integrations
</template>

<script>
import Slack from '../api/slack';

export default {
  name: 'SlackChannel',
  props: {
    value: {
      type: Object
    }
  },
  async mounted() {
    await this.loadChannels();
  },
  methods: {
    async loadChannels() {
      try {
        this.loading = true;
        const list = await Slack.channels();
        this.channels = list.map((it) => ({name: it.name, id: it.id}));
      } catch (e) {
        console.error(e);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    change(v) {
      console.log(v);
      this.$emit('input', v);
    }
  },
  data() {
    return {
      error: false,
      loading: false,
      channels: [],
      required: [(v) => !!v || 'Required field']
    };
  }
};
</script>

<style scoped>

</style>
